// extracted by mini-css-extract-plugin
export default {"main":"ahQE4uy","errorMessage":"OB5QPJC","face":"SlVXBSW","heading":"UersF3A AAonn85 london2","para":"gVURAh6 ZHWKoMf leavesden3"};